export default __webpack_public_path__ + "static/media/bh.de2af65e.jpg";